export const PORTFOLIO_ACCESS_UNAVAILABLE = {
    title: "Portfolio unavailable",
    message: "Sorry, your dashboard and portfolio are currently unavailable. If you need any immediate help, please call us on 0800 028 3200."
};

export const DOCUMENT_ACCESS_UNAVAILABLE = {
    title: "Documents unavailable",
    message: "Sorry, your documents are currently unavailable. If you need any immediate help, please call us on 0800 028 3200."
};